import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image = '/images/hero.png',
  type = 'website'
}) => {
  const location = useLocation();
  const baseUrl = 'https://mskandsportsphysio.com';
  const currentUrl = `${baseUrl}${location.pathname}`;
  
  // Business info for schema
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "@id": "https://mskandsportsphysio.com",
    "name": "MSK and Sports Physio",
    "alternateName": "MSK and Sports Physiotherapy",
    "description": "Expert physiotherapy care for sports injuries, post-operative recovery, and pain management in Harrow. MSc qualified physiotherapist with 7+ years experience at HarroWall Climbing Centre.",
    "url": "https://mskandsportsphysio.com",
    "telephone": "+447747075809",
    "email": "mskandsportsphysio@gmail.com",
    "priceRange": "££",
    "image": image,
    "logo": "https://mskandsportsphysio.com/images/logo.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "HarroWall Climbing Centre, Neptune Trading Estate, Neptune Rd",
      "addressLocality": "Harrow",
      "addressRegion": "Greater London",
      "postalCode": "HA1 4HX",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.5938365",
      "longitude": "-0.3550715"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "19:00"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Physiotherapy Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Sports Injury Rehabilitation",
            "description": "Expert treatment for runners, football players, tennis players, and athletes of all sports"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "MSK Physiotherapy",
            "description": "Evidence-based treatment for muscle, bone, and joint conditions including back pain and arthritis"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Post-Operative Rehabilitation",
            "description": "Comprehensive post-surgery rehab programs for ACL reconstruction and joint replacements"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Paediatric Sports Physiotherapy",
            "description": "Specialist physiotherapy for young athletes and growing pains"
          }
        }
      ]
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Harrow"
      },
      {
        "@type": "City",
        "name": "London"
      },
      {
        "@type": "City",
        "name": "Wembley"
      },
      {
        "@type": "City",
        "name": "Stanmore"
      },
      {
        "@type": "City",
        "name": "Pinner"
      }
    ],
    "paymentAccepted": "Cash, Credit Card, Debit Card, Insurance",
    "medicalSpecialty": ["Physiotherapy", "Sports Medicine", "Musculoskeletal Medicine"],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5",
      "reviewCount": "50",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://www.google.com/maps/place/MSK+%26+Sports+Physio"
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={currentUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="MSK and Sports Physio" />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={currentUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="geo.region" content="GB-HAR" />
      <meta name="geo.placename" content="Harrow" />
      <meta name="geo.position" content="51.5938365;-0.3550715" />
      <meta name="ICBM" content="51.5938365, -0.3550715" />
      
      {/* Schema.org Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;